import { render, staticRenderFns } from "./CreativeTestsBrandView.vue?vue&type=template&id=b5bd0b20&scoped=true"
import script from "./CreativeTestsBrandView.vue?vue&type=script&lang=js"
export * from "./CreativeTestsBrandView.vue?vue&type=script&lang=js"
import style0 from "./CreativeTestsBrandView.vue?vue&type=style&index=0&id=b5bd0b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd0b20",
  null
  
)

export default component.exports